"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpHandlerChannelStatus = void 0;
/**
 * Статус канала аутентификации
 * @beta
 */
var EOtpHandlerChannelStatus;
(function (EOtpHandlerChannelStatus) {
    /**
     * В процессе
     */
    EOtpHandlerChannelStatus["wait"] = "wait";
    /**
     * Пользователю что-то отправленно
     */
    EOtpHandlerChannelStatus["sent"] = "sent";
    /**
     * Канал закрыт из-за ошибки
     */
    EOtpHandlerChannelStatus["error"] = "error";
    /**
     * Успешное завершение
     */
    EOtpHandlerChannelStatus["confirmed"] = "confirmed";
    /**
     * Принудительное закрытие
     */
    EOtpHandlerChannelStatus["closed"] = "closed";
})(EOtpHandlerChannelStatus || (exports.EOtpHandlerChannelStatus = EOtpHandlerChannelStatus = {}));
//# sourceMappingURL=OtpHandlerChannelStatus.enum.js.map